export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ForwardWhite.dbc6395e.svg","height":15,"width":9,"blurWidth":0,"blurHeight":0};